var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: !_vm.recLoaded } },
        [
          _vm.overlay
            ? _c(
                "contentTitle",
                { attrs: { label: "OVERLAY", close: "home" } },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.overlay.name))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.overlay
            ? _c(
                "contentBody",
                { attrs: { locked: _vm.token === null } },
                [
                  _vm.overlay
                    ? _c("contentActions", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            class: { active: _vm.shareShown === true },
                            on: { click: _vm.share }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "share overlay" }
                              },
                              [_vm._v("share")]
                            ),
                            _vm._v(" \n\t\t\t\tShare\n\t\t\t")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            on: { click: _vm.zoomTo }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "center map on overlay" }
                              },
                              [_vm._v("place")]
                            ),
                            _vm._v(" \n\t\t\t\tCenter\n\t\t\t")
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isAdmin
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-light btn-sm",
                                on: { click: _vm.edit }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons md-18",
                                    attrs: { title: "edit overlay" }
                                  },
                                  [_vm._v("edit")]
                                ),
                                _vm._v(" \n\t\t\t\tEdit\n\t\t\t")
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shareShown
                    ? _c("share", {
                        attrs: { link: _vm.location },
                        on: { close: _vm.share }
                      })
                    : _c("div", [
                        _c("div", { staticClass: "p-3" }, [
                          _vm.token === null
                            ? _c("div", { staticClass: "lock-block" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row mx-0 hover-dk",
                                    on: { click: _vm.routeLogin }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-2 text-center my-auto"
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons text-light mr-3 md-36"
                                          },
                                          [_vm._v("account_box")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "py-3 col-10 pl-0 pr-3 py-3"
                                      },
                                      [
                                        _c(
                                          "h5",
                                          { staticClass: "mb-0 text-white" },
                                          [_vm._v("Sign in to view")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "mb-0 font-weight-light text-light"
                                          },
                                          [
                                            _vm._v(
                                              "Get details on overlay parcel restrictions"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "category-body" }, [
                            _c("div", { staticClass: "category" }, [
                              _c("div", { staticClass: "category-title" }, [
                                _vm._v("DESCRIPTION")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "property-row" }, [
                                _c("div", { staticClass: "text-break" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.overlay.description ||
                                          "No description available"
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.overlay.details
                              ? _c(
                                  "div",
                                  { staticClass: "category" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "category-title" },
                                      [_vm._v("DETAILS")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.overlay.details, function(
                                      detail,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        { staticClass: "property-row" },
                                        [
                                          _c("label", [
                                            _vm._v(_vm._s(detail.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "property-value-right property-locked"
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(detail.value || "-") +
                                                  "\n\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.overlay.jurisdiction !== null &&
                            _vm.overlay.jurisdiction.name !== null
                              ? _c("div", { staticClass: "category" }, [
                                  _c("div", { staticClass: "category-title" }, [
                                    _vm._v("JURISDICTION")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "property-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-description property-locked"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.overlay.jurisdiction.name)
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isReference(_vm.overlay)
                              ? _c(
                                  "div",
                                  { staticClass: "category" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "category-title" },
                                      [_vm._v("REFERENCES")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.overlay.references, function(
                                      ref,
                                      idx
                                    ) {
                                      return _c(
                                        "div",
                                        { staticClass: "property-row" },
                                        [
                                          _c("label", [
                                            _vm._v(_vm._s(ref.description))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "property-value-right"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: ref.url,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons md-12"
                                                    },
                                                    [_vm._v("open_in_new")]
                                                  ),
                                                  _vm._v(" Link")
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5343484a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5343484a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overlay/overlay-full.vue
// module id = null
// module chunks = 